(function(MapShared) {
    'use strict';

    MapShared.style = [{
        'featureType': 'landscape',
        'elementType': 'geometry.fill',
        'stylers': [{
            'visibility': 'on'
        }, {
            'color': '#f0f0f0 '
        }]
    }, {
        'featureType': 'poi',
        'stylers': [{
            'visibility': 'off'
        }]
    }, {
        'featureType': 'road.highway',
        'elementType': 'geometry.stroke',
        'stylers': [{
            'color': '#808080 '
        }, {
            'visibility': 'on'
        }]
    }, {
        'featureType': 'road',
        'elementType': 'labels',
        'stylers': [{
            'visibility': 'off'
        }]
    }, {
        'featureType': 'road.highway',
        'elementType': 'geometry.fill',
        'stylers': [{
            'color': '#D3D2D4'
        }]
    }, {
        'featureType': 'transit',
        'elementType': 'geometry.fill',
        'stylers': [{
            'color': '#B7B5B9'
        }, {
            'visibility': 'on'
        }]
    }, {
        'featureType': 'water',
        'elementType': 'geometry.fill',
        'stylers': [{
            'color': '#ECEDF1'
        }]
    }, {
        'featureType': 'administrative.province',
        'elementType': 'labels',
        'stylers': [{
            'visibility': 'off'
        }]
    }, {
        'featureType': 'administrative.province',
        'elementType': 'geometry',
        'stylers': [{
            'visibility': 'off'
        }]
    }, {
        'featureType': 'administrative.neighborhood',
        'elementType': 'labels',
        'stylers': [{
            'visibility': 'off'
        }]
    }, {
        'featureType': 'administrative.locality',
        'stylers': [{
            'visibility': 'simplified'
        }]
    }];

    MapShared.clusterStyle = {
        styles: [{
            url: wpData.uriAssets + 'img/clusters/m1.png',
            textColor: '#fff',
            height: 52,
            width: 53
        }, {
            url: wpData.uriAssets + 'img/clusters/m2.png',
            textColor: '#fff',
            height: 55,
            width: 56
        }, {
            url: wpData.uriAssets + 'img/clusters/m3.png',
            textColor: '#fff',
            height: 65,
            width: 66
        }, {
            url: wpData.uriAssets + 'img/clusters/m4.png',
            textColor: '#fff',
            height: 77,
            width: 78
        }, {
            url: wpData.uriAssets + 'img/clusters/m5.png',
            textColor: '#fff',
            height: 89,
            width: 90
        }]
    };


})(window.Way2web.MapShared = window.Way2web.MapShared || {});
